import { performQuery, performMutation } from "../../service/graphql"
import * as Query from "../../service/graphql/apiQuery"

export const GetBlogs = () => {
    // console.log("GetCatagories");
    return performQuery(Query.getBlogsList, null).then(response => {
        console.log(response?.data,'hi');
        return response?.data || []
    }).catch((err) => {
        console.log(err, "getblogs error");
    })
};

export const GetBlogsPaging = (data) => {
    // console.log("GetCatagories");
    return performQuery(Query.getBlogsListPaging, data).then(response => {
        return response?.data || []
    }).catch((err) => {
        console.log(err, "GetBlogsPaging error");
    })
};

export const GetBlogsPagingPrevious = (data) => {
    // console.log("GetCatagories");
    return performQuery(Query.getBlogPrevious, data).then(response => {
        return response?.data || []
    }).catch((err) => {
        console.log(err, "GetBlogsPagingPrevious error");
    })
};

export const GetBlogBySlug = (slug) => {
    return performQuery(Query.getBlogBySlug, { slug: `${slug}` })
        .then(response => {
            return response?.data?.articles?.nodes[0] || null; // Fetch first node
        })
        .catch((err) => {
            console.log(err, "GetBlogBySlug error");
        });
};
